module.exports = __webpack_public_path__ + "img/arrow-active.4751105d.svg";